const tiktokRoutes = [
  {
    path: "/tiktok",
    name: "TikTok",
    component: () => import("@/views/campains/tiktok/TikTokIndex.vue"),
    meta: {
      title: "tiktok",
      permissions: [
        "campaign-ads.create",
        "campaign-ads.read",
        "campaign-ads.update",
        "campaign-ads.delete",
      ],
    },
  },
  {
    path: "/create/adgroup",
    name: "TikTokSecoundStep",
    component: () => import("@/views/campains/tiktok/TiktokSecoundStep.vue"),
    meta: {
      title: "tiktok",
      permissions: [
        "campaign-ads.create",
        "campaign-ads.read",
        "campaign-ads.update",
        "campaign-ads.delete",
      ],
    },
  },
  {
    path: "/create/creative",
    name: "TiktokThirdStep",
    component: () => import("@/views/campains/tiktok/TiktokThirdStep.vue"),
    meta: {
      title: "tiktok",
      permissions: [
        "campaign-ads.create",
        "campaign-ads.read",
        "campaign-ads.update",
        "campaign-ads.delete",
      ],
    },
  },
  {
    path: "/create-campaign/tiktok",
    name: "CreatTiktokCampaign",
    component: () => import("@/views/campains/tiktok/CreatTiktokCampaign.vue"),
    meta: {
      title: "tiktok",
      permissions: [
        "campaign-ads.create",
        "campaign-ads.read",
        "campaign-ads.update",
        "campaign-ads.delete",
      ],
    },
  },
  {
    path: "/tiktokToken",
    name: "TiktokToken",
    component: () => import("@/views/campains/tiktok/getTiktokToken.vue"),
    meta: {
      title: "tiktok",
      permissions: [
        "campaign-ads.create",
        "campaign-ads.read",
        "campaign-ads.update",
        "campaign-ads.delete",
      ],
    },
  },
  {
    path: "/tiktok/select-your-acount",
    name: "SelectYourAcount",
    component: () => import("@/views/campains/tiktok/SelectYourAcount.vue"),
    meta: {
      title: "tiktok",
      permissions: [
        "campaign-ads.create",
        "campaign-ads.read",
        "campaign-ads.update",
        "campaign-ads.delete",
      ],
    },
  },
  {
    path: "/tiktok/create-app",
    name: "CreateApp",
    component: () => import("@/views/campains/tiktok/CreateApp.vue"),
    meta: {
      title: "tiktok",
      permissions: [
        "campaign-ads.create",
        "campaign-ads.read",
        "campaign-ads.update",
        "campaign-ads.delete",
      ],
    },
  },
];

export default tiktokRoutes;
